import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators'
import { EmptyHomeState, HomeState } from '@/business/home/store/home-state'
import { FETCH_UPDATES, SET_HOME } from '@/business/home/store/types'
import { Loading } from '@/shared/utils/vuex-loading'
import { Api } from '@/api/api'
import { toPortfolioItem } from '@/shared/utils/portfolio'
import { BlogList } from '@/api/generated'

const STORE_NAME = 'home'

@Module({
  name: STORE_NAME,
})
export class HomeModule extends VuexModule {
  public static readonly STORE_NAME: string = STORE_NAME

  public data: HomeState = EmptyHomeState
  public updates: BlogList = { items: [] }

  @Mutation
  public [SET_HOME](state: HomeState) {
    this.data = state
  }

  @Mutation
  public [FETCH_UPDATES](posts: BlogList) {
    this.updates = posts
  }

  @Loading(SET_HOME)
  @Action({
    commit: SET_HOME,
    rawError: true,
  })
  public fetchHomeData(): Promise<HomeState> {
    return Api.Frontend.getHome({
      project: 'home',
    }).then(response => {
      const homeState: HomeState = {
        offers: response.offers.map(toPortfolioItem('offers', 'offer')),
        organisations: response.organisations.map(toPortfolioItem('organisations', 'organisation')),
      }

      return homeState
    })
  }

  @Loading(FETCH_UPDATES)
  @Action({
    commit: FETCH_UPDATES,
    rawError: true,
  })
  public async fetchUpdates(): Promise<BlogList> {
    return Api.Frontend.getUpdates()
  }
}
